/* eslint-disable import/prefer-default-export */

export const browserLocation = window.location;
